import ApplicantName from './ApplicantName';

export default ApplicantName;
